import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import "spectre.css/dist/spectre.min.css";
import styled from "styled-components";
import "../../node_modules/react-vis/dist/style.css";
import BreadCrumbsNavbar from "../components/BreadCrumbsNavbar";
import {
  BCDemoContainer,
  BCDemoMain,
  Bold16,
  Card,
  ResultsContainer,
  ScrollingCard,
  getRandomLinkId,
  Banner1,
  ProceedButton,
} from "../components/common";
import help from "../bankconnect/images/helpIcon.svg";
import { MdClose } from "react-icons/md";
import APIModal from "../components2/APIModal";
import { v4 as uuidv4 } from "uuid";
import DemoErrorState from "../components/DemoErrorState";
import GenericErrorState from "../components/GenericErrorState";

import { Tab, Tabs } from "../components/TabNavigation";
import CategoryChip from "../components2/CategoryChip";
import Guitar from "../components2/Guitar";
import Line from "../components2/Line";
import Multiple from "../components2/Multiple";
import BarChart from "../components2/BarChart";
import Donut from "../components2/Donut";
import NormalTable from "../components2/NormalTable";
import Table from "../components2/RecurringTable";
import FraudTable from "../components2/FraudTable";
import Sidebar from "../components2/Sidebar";
import AppContext from "../context/AppContext";
import ThemeContext from "../context/ThemeContext";
import { FinBoxBankConnect } from "finbox-bank-connect-js";
import "../bankconnect/bankconnect.scss";

import "./Settings.scss";
import Finboxsdk from "../components/Finboxsdk";

const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  opacity: 1;
  width: 100vw;
  height: 100vh;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: start;
`;

const CDChip = styled.div`
  background: ${(props) => props.theme[props.type]};
  padding: 10px 30px;
  border-radius: 10px;
  display: flex;
  margin-bottom: 10px;
  flex-direction: column;
`;

const Label = styled.div`
  font-size: 12px;
`;

const BalanceHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 25px 25px 25px 0px;
  color: ${(props) =>
    props.theme.name === "dark" ? props.theme.main : props.theme.txt};
`;

const tabLabels = [
  {
    name: "Overview",
  },
  {
    name: "Salary",
  },
  {
    name: "Recurring",
  },
  {
    name: "Transactions",
  },
  {
    name: "Loans",
  },
  {
    name: "Frauds",
  },
];

const formatSalary = (resp) => {
  const toRet = resp.map((res) => {
    return {
      x: new Date(res.date),
      y: 0,
      size: res.amount,
      color: 0,
      opacity: 1,
    };
  });
  toRet.push({ x: null, y: 1 });
  toRet.push({ x: null, y: -1 });
  return { data: toRet, labels: ["Salary"] };
};
const formatRecurring = (resp) => {
  const { credit_transactions, debit_transactions } = resp;
  const top6 = [
    ...credit_transactions
      .sort((a, b) => b.transactions.length - a.transactions.length)
      .slice(0, 3),
    ...debit_transactions
      .sort((a, b) => b.transactions.length - a.transactions.length)
      .slice(0, 3),
  ];
  const labels = [];
  const toRet = [];
  top6.forEach((transCollection, transIndex) => {
    labels[transIndex] =
      transCollection.clean_transaction_note &&
      transCollection.clean_transaction_note != ""
        ? transCollection.clean_transaction_note
        : transCollection.transaction_channel;
    transCollection.transactions.forEach((res, resIndex) => {
      toRet.push({
        x: new Date(res.date),
        y: transIndex,
        size: res.amount,
        color: transIndex,
        opacity: 0.7,
      });
    });
  });
  return { data: toRet, labels };
};
const renderKeys = (product, dna) => {
  switch (product.name) {
    case "Overview":
      return Overview(dna);
    case "Salary":
      return Salaried(dna);
    case "Recurring":
      return Recurring(dna);
    case "Transactions":
      return Transactions(dna);
    case "Loans":
      return Loans(dna);
    case "Frauds":
      return Frauds(dna);
  }
};

const extractMult = (metrics) => {
  if (!metrics) return [];
  const { credit_debit_month_wise } = metrics;
  const credits = [];
  const debits = [];
  const sorted = credit_debit_month_wise
    .map((v) => ({
      ...v,
      month: parseInt(moment(v.month + "-01").valueOf() / 1000),
    }))
    .sort((a, b) => b.month - a.month);
  for (let monthObj of sorted) {
    const month = monthObj.month;
    credits.push({
      x: month,
      y: monthObj.credit,
    });
    debits.push({
      x: month,
      y: monthObj.debit,
    });
  }
  return [credits, debits];
};
const extractBar = (metrics) => {
  if (!metrics) return [];
  const { credit_debit_month_wise } = metrics;
  const credits = [];
  const debits = [];
  const sorted = credit_debit_month_wise
    .map((v) => ({
      ...v,
      month: parseInt(moment(v.month + "-01").valueOf() / 1000),
    }))
    .sort((a, b) => a.month - b.month);
  for (let monthObj of sorted) {
    const month = monthObj.month;
    credits.push({
      x: month,
      y: monthObj.credit,
    });
    debits.push({
      x: month,
      y: monthObj.debit,
    });
  }
  return [credits, debits];
};
const extractCD = (metrics) => {
  if (!metrics) return null;
  const {
    avg_credit,
    avg_debit,
    max_credit_txn,
    max_debit_txn,
    avg_monthly_debit,
    avg_monthly_credit,
  } = metrics;
  return {
    avg: {
      credit: avg_credit,
      debit: avg_debit,
    },
    max: {
      credit: max_credit_txn ? max_credit_txn.amount : 0,
      debit: max_debit_txn ? max_debit_txn.amount : 0,
    },
    size: {
      credit: avg_monthly_credit,
      debit: avg_monthly_debit,
    },
  };
};
const extractBalanceHeaders = (metrics) => {
  if (!metrics) return [];
  return [
    {
      val: metrics.max_balance,
      label: "Maximum Balance",
    },
    {
      val: metrics.avg_balance,
      label: "Average Balance",
    },
    {
      val: metrics.min_balance,
      label: "Minimum Balance",
    },
  ];
};
const extractBalanceTS = (metrics) => {
  if (!metrics) return [];
  const res = metrics.balance_ts.map((obj) => ({
    x: obj.date,
    y: obj.balance,
  }));
  return res;
};
const extractCategories = async (context, setCategories, entity_id) => {
  var myHeaders = new Headers();
  let apiKey = context.bankConnectApiKey;
  myHeaders.append("x-api-key", apiKey);
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const dnResponse = await fetch(
    `https://portal.finbox.in/bank-connect/v1/entity/${entity_id}/get_expense_categories/`,
    requestOptions
  );
  const dnResultTxt = await dnResponse.text();
  const dnResult = JSON.parse(dnResultTxt);
  setCategories(dnResult);
};
const toINR = (num, acc, accountNum) => {
  let currAcc = acc.filter((acc) => acc.account_id == accountNum);
  // console.log(currAcc);
  return (
    (currAcc[0].bank == "ncb" || currAcc[0].bank == "alrajhi" ? "SAR " : "₹ ") +
    parseInt(num).toLocaleString("en-IN")
  );
};
const downloadReport = async (
  context,
  setDownloadState,
  setDownloadLink,
  entity_id
) => {
  var myHeaders = new Headers();
  let apiKey = context.bankConnectApiKey;
  myHeaders.append("x-api-key", apiKey);
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const dnResponse = await fetch(
    `https://portal.finbox.in/bank-connect/v1/entity/${entity_id}/xlsx_report/`,
    requestOptions
  );
  const dnResultTxt = await dnResponse.text();
  const dnResult = JSON.parse(dnResultTxt);
  setDownloadLink(dnResult.reports);
  // console.log(dnResult.reports);
  setDownloadState("loaded");
};

function Spinnex(props) {
  const [trig, setTrig] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setTrig(true);
    }, 100);
  }, []);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        marginBottom: 20,
      }}
    >
      <div className="checkmark">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0, 0, 100, 100"
          id="checkmark"
        >
          <g transform="">
            <circle
              className={trig ? "path path-complete success" : "path"}
              fill="none"
              stroke="#7DB0D5"
              stroke-width="10"
              stroke-miterlimit="10"
              cx="50"
              cy="50"
              r="44"
            />
            <circle
              className={trig ? "fill fill-complete success" : "fill"}
              fill="none"
              stroke="#7DB0D5"
              stroke-width="10"
              stroke-miterlimit="10"
              cx="50"
              cy="50"
              r="44"
            />
            <polyline
              className={trig ? "check check-complete success" : "check"}
              fill="none"
              stroke="#7DB0D5"
              stroke-width="1"
              stroke-linecap="round"
              stroke-miterlimit="5"
              points="70,35 45,65 30,52  "
            />
          </g>
        </svg>
      </div>
      <div>{props.children}</div>
    </div>
  );
}

const Overview = (dna) => {
  let count = 0;
  console.log("rerender check");
  const { theme } = useContext(ThemeContext);
  const timer = useRef();
  const Up = () => {
    timer.current = setTimeout(() => {
      count = count + 1;
    }, 1000);
  };
  if (!dna.metrics.result || timer.current < 30) {
    Up();
    return (
      <>
        <div
          style={{
            width: "100%",
            marginTop: "20%",
            marginLeft: "40%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {timer.current > -1 && <Spinnex>Getting account information</Spinnex>}
          {timer.current > 1 && <Spinnex>Fetching Balance Details</Spinnex>}
          {timer.current > 5 && <Spinnex>Fetching Transactions</Spinnex>}
          {timer.current > 10 && <Spinnex>Plotting Graphs</Spinnex>}
          {timer.current > 16 && (
            <Spinnex>Extracting salary and loan details</Spinnex>
          )}
        </div>
      </>
    );
  }
  const pickedMetrics = dna.metrics.result.metrics.account_wise_metrics.find(
    (v) => v.account_id === dna.accountNum
  );
  const balance_headers = extractBalanceHeaders(pickedMetrics);
  const balance_ts = extractBalanceTS(pickedMetrics);
  const cd_summary = extractCD(pickedMetrics);
  const mult_data = extractMult(pickedMetrics);
  const bar_data = extractBar(pickedMetrics);
  let cats = null;

  // console.log(bar_data);

  return (
    <div className="container">
      <div className="columns">
        <div className="column col-12">
          <Bold16>Balance</Bold16>
          <BalanceHeader theme={theme}>
            {balance_headers.map((hdr, hdrInd) => (
              <div key={hdrInd}>
                <Bold16>
                  {toINR(hdr.val, dna.identity.result.accounts, dna.accountNum)}
                </Bold16>
                <Label>{hdr.label}</Label>
              </div>
            ))}
          </BalanceHeader>
        </div>

        <div className="column col-12">
          {balance_ts.length && <Line data={balance_ts} />}
        </div>
        <div className="column col-12" style={{ marginTop: 30 }}>
          <Bold16>Credits and Debits</Bold16>
          <div>
            {/* <Multiple data={mult_data} items={["Credit", "Debit"]} /> */}
            {bar_data.length && (
              <BarChart data={bar_data} items={["Credit", "Debit"]} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

function Salaried(dna) {
  if (!dna.salary.result) {
    return <div className="loading"></div>;
  }

  const filteredTransactions = dna.salary.result.transactions
    .filter((v) => v.account_id === dna.accountNum)
    .reverse();
  return (
    <div className="">
      <APIModal
        name="Salaried Transactions"
        apilink="https://docs.finbox.in/bank-connect/rest-api.html#salary"
        code={dna.salary.code}
        setModal={dna.setShowSalaryModal}
        showModal={dna.showSalaryModal}
        data={filteredTransactions}
      />

      <Guitar data={filteredTransactions} formatter={formatSalary} eq />
      <NormalTable data={filteredTransactions} />
    </div>
  );
}

function Transactions(dna) {
  if (!dna.metrics.result || !dna.transactions.result) {
    return <div className="loading"></div>;
  }
  const pickedMetrics = dna.metrics.result.metrics.account_wise_metrics.find(
    (v) => v.account_id === dna.accountNum
  );
  const mult_data = extractMult(pickedMetrics);
  // dna.categories && console.log(dna.categories);
  const filteredTransactions = dna.transactions.result.transactions
    .filter((v) => v.account_id === dna.accountNum)
    .reverse();
  return (
    <div className="">
      <APIModal
        name="Transactions"
        apilink="https://docs.finbox.in/bank-connect/rest-api.html#transactions"
        code={dna.transactions.code}
        setModal={dna.setShowTransactionModal}
        showModal={dna.showTransactionModal}
        data={filteredTransactions}
      />
      {dna.categories.categories && (
        <div
          style={{
            display: "flex",
            margin: "10px 0 30px",
            alignItems: "center",
          }}
        >
          <Donut data={dna.categories.categories} />
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              height: "180px",
              minWidth: "400px",
              width: "400px",
              marginLeft: "10%",
            }}
          >
            {" "}
            {dna.categories.categories.map((category, index) =>
              index < 6 ? <CategoryChip category={category} /> : ""
            )}
          </div>
        </div>
      )}
      {/* <Categories>
            {dna.categories.categories &&
              dna.categories.categories.map((category) => (
                <CategoryChip category={category} />
              ))}
          </Categories> */}
      <NormalTable data={filteredTransactions} />
    </div>
  );
}

function Recurring(dna) {
  if (!dna.recurring.result) return <div className="loading"></div>;
  const { credit_transactions, debit_transactions } =
    dna.recurring.result.transactions;
  const recurring_data = {
    credit_transactions: credit_transactions.filter(
      (v) => v.account_id === dna.accountNum
    ),
    debit_transactions: debit_transactions.filter(
      (v) => v.account_id === dna.accountNum
    ),
  };
  // const pickedMetrics = dna.metrics.metrics.account_wise_metrics.find(v=>v.account_id === dna.accountNum);
  return (
    <div className="">
      <APIModal
        name="Recurring Transactions"
        apilink="https://docs.finbox.in/bank-connect/rest-api.html#recurring-transactions"
        code={dna.recurring.code}
        setModal={dna.setShowRecurringModal}
        showModal={dna.showRecurringModal}
        data={recurring_data}
      />
      <Card>
        <Guitar data={recurring_data} formatter={formatRecurring} />
        <Table data={recurring_data} />
      </Card>
    </div>
  );
}

function Loans(dna) {
  if (!dna.lender.result) {
    return <div className="loading"></div>;
  }
  const filteredTransactions = dna.lender.result.transactions
    .filter((v) => v.account_id === dna.accountNum)
    .reverse();
  return (
    <div>
      <APIModal
        name="Loan Transactions"
        apilink="https://docs.finbox.in/bank-connect/rest-api.html#lender-transactions"
        code={dna.lender.code}
        setModal={dna.setShowLenderModal}
        showModal={dna.showLenderModal}
        data={filteredTransactions}
      />
      <Guitar data={filteredTransactions} formatter={formatSalary} eq />
      <NormalTable data={filteredTransactions} style={{ marginTop: "25px" }} />
    </div>
  );
}

function Frauds(dna) {
  if (!dna.salary.result) {
    return <div className="loading"></div>;
  }

  return (
    dna.salary.result &&
    dna.transactions.result && (
      <div>
        {dna.salary.result.fraud.fraud_type.length == 0 ? (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              marginTop: "50px",
            }}
          >
            <img
              src="https://finbox-cdn.s3.ap-south-1.amazonaws.com/assets/dashboard/No+data-amico+1.svg"
              height={200}
            />
            <p className="empty-title h5">No records found</p>
          </div>
        ) : (
          <FraudTable
            data={dna.salary.result.fraud.fraud_type}
            transactions={dna.transactions.result.transactions}
          />
        )}
      </div>
    )
  );
}

let timerSalary;
let timerIdentity;
let timerMetrics;
let timerTransaction;
let timerRecurring;
let timerLender;

function pollSalary(context, toSet, uri, entity_id, cond) {
  let apiKey = context.bankConnectApiKey;
  var myHeaders = new Headers();
  myHeaders.append("x-api-key", apiKey);
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  fetch(
    `https://portal.finbox.in/bank-connect/v1/entity/${entity_id}/${uri}/`,
    requestOptions
  )
    .then((res) => res.json())
    .then((data) => {
      if (
        data.progress.some((row) => {
          return row.status === "processing";
        })
      ) {
        clearInterval(timerSalary);
        timerSalary = setInterval(
          pollSalary,
          5000,
          context,
          toSet,
          uri,
          entity_id,
          cond
        );
      } else if (
        data.progress.every(
          (pro) => pro.status === "completed" || pro.status === "failed"
        )
      ) {
        console.log(timerSalary);
        clearInterval(timerSalary);
        toSet({ result: data, code: JSON.stringify(data, null, 4) });
      }
      if (data.progress.every((pro) => pro.status === "failed")) {
        cond(true);
      }
    });
}
function pollMetrics(context, toSet, uri, entity_id, cond) {
  let apiKey = context.bankConnectApiKey;
  var myHeaders = new Headers();
  myHeaders.append("x-api-key", apiKey);
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  fetch(
    `https://portal.finbox.in/bank-connect/v1/entity/${entity_id}/${uri}/`,
    requestOptions
  )
    .then((res) => res.json())
    .then((data) => {
      if (
        data.progress.some((row) => {
          return row.status === "processing";
        })
      ) {
        clearInterval(timerMetrics);
        timerMetrics = setInterval(
          pollMetrics,
          5000,
          context,
          toSet,
          uri,
          entity_id,
          cond
        );
      } else if (
        data.progress.every(
          (pro) => pro.status === "completed" || pro.status === "failed"
        )
      ) {
        clearInterval(timerMetrics);
        toSet({ result: data, code: JSON.stringify(data, null, 4) });
      }
      if (data.progress.every((pro) => pro.status === "failed")) {
        cond(true);
      }
    });
}
function pollIdentity(context, toSet, uri, entity_id, cond, cond1, cond2) {
  let apiKey = context.bankConnectApiKey;
  var myHeaders = new Headers();
  myHeaders.append("x-api-key", apiKey);
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  fetch(
    `https://portal.finbox.in/bank-connect/v1/entity/${entity_id}/${uri}/`,
    requestOptions
  )
    .then((res) => res.json())
    .then((data) => {
      if (
        data.progress.some((row) => {
          return row.status === "processing";
        })
      ) {
        clearInterval(timerIdentity);
        timerIdentity = setInterval(
          pollIdentity,
          5000,
          context,
          toSet,
          uri,
          entity_id,
          cond,
          cond1,
          cond2
        );
      } else if (
        data.progress.every(
          (pro) => pro.status === "completed" || pro.status === "failed"
        )
      ) {
        clearInterval(timerIdentity);
        const filteredAcc = data.accounts.filter(
          (item) => item.account_number !== null
        );
        if (filteredAcc.length > 0) {
          data.accounts = [...filteredAcc];
          data.identity = [
            ...data.identity.filter((item) => item.account_number !== null),
          ];
        } else {
          data.accounts = [data.accounts[0]];
          data.identity = [
            ...data.identity.filter(
              (item) => item.account_number === data.accounts[0]
            ),
          ];
        }

        toSet({ result: data, code: JSON.stringify(data, null, 4) });
        let validIndex = [];
        data.progress.forEach((state, ind) => {
          if (state.status === "completed") {
            validIndex.push(ind);
          }
        });
        cond2(validIndex);
        cond1(data.accounts[0].account_id);
        // cond1(data.accounts[validIndex[0]].account_id);
      }
      if (data.progress.every((pro) => pro.status === "failed")) {
        cond(true);
      }
    });
}
function pollRecurring(context, toSet, uri, entity_id, cond, cond1) {
  let apiKey = context.bankConnectApiKey;
  var myHeaders = new Headers();
  myHeaders.append("x-api-key", apiKey);
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  fetch(
    `https://portal.finbox.in/bank-connect/v1/entity/${entity_id}/${uri}/`,
    requestOptions
  )
    .then((res) => res.json())
    .then((data) => {
      if (
        data.progress.some((row) => {
          return row.status === "processing";
        })
      ) {
        clearInterval(timerRecurring);
        timerRecurring = setInterval(
          pollRecurring,
          5000,
          context,
          toSet,
          uri,
          entity_id,
          cond,
          cond1
        );
      } else if (
        data.progress.every(
          (pro) => pro.status === "completed" || pro.status === "failed"
        )
      ) {
        clearInterval(timerRecurring);
        toSet({ result: data, code: JSON.stringify(data, null, 4) });
        downloadReport(context, cond, cond1, entity_id);
      }
      if (data.progress.every((pro) => pro.status === "failed")) {
        cond(true);
      }
    });
}
function pollLender(context, toSet, uri, entity_id, cond) {
  let apiKey = context.bankConnectApiKey;
  var myHeaders = new Headers();
  myHeaders.append("x-api-key", apiKey);
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  fetch(
    `https://portal.finbox.in/bank-connect/v1/entity/${entity_id}/${uri}/`,
    requestOptions
  )
    .then((res) => res.json())
    .then((data) => {
      if (
        data.progress.some((row) => {
          return row.status === "processing";
        })
      ) {
        clearInterval(timerLender);
        timerLender = setInterval(
          pollLender,
          5000,
          context,
          toSet,
          uri,
          entity_id,
          cond
        );
      } else if (
        data.progress.every(
          (pro) => pro.status === "completed" || pro.status === "failed"
        )
      ) {
        clearInterval(timerLender);
        toSet({ result: data, code: JSON.stringify(data, null, 4) });
      }
      if (data.progress.every((pro) => pro.status === "failed")) {
        cond(true);
      }
    });
}
function pollTransaction(context, toSet, uri, entity_id, cond, cond1) {
  let apiKey = context.bankConnectApiKey;
  var myHeaders = new Headers();
  myHeaders.append("x-api-key", apiKey);
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  fetch(
    `https://portal.finbox.in/bank-connect/v1/entity/${entity_id}/${uri}/`,
    requestOptions
  )
    .then((res) => res.json())
    .then((data) => {
      if (
        data.progress.some((row) => {
          return row.status === "processing";
        })
      ) {
        clearInterval(timerTransaction);
        timerTransaction = setInterval(
          pollTransaction,
          5000,
          context,
          toSet,
          uri,
          entity_id,
          cond,
          cond1
        );
      } else if (
        data.progress.every(
          (pro) => pro.status === "completed" || pro.status === "failed"
        )
      ) {
        clearInterval(timerTransaction);
        const filteredAcc = data.accounts.filter(
          (item) => item.account_number !== null
        );
        if (filteredAcc.length > 0) data.accounts = [...filteredAcc];
        else data.accounts = [data.accounts[0]];

        toSet({ result: data, code: JSON.stringify(data, null, 4) });
        extractCategories(context, cond1, entity_id);
      }
      if (data.progress.every((pro) => pro.status === "failed")) {
        cond(true);
      }
    });
}
function addMonths(date, months) {
  date.setMonth(date.getMonth() + months);
  return date;
}
function BCDemo(props) {
  const context = useContext(AppContext);
  const [accountNum, setAccountNum] = useState(null);
  const [identity, setIdentity] = useState({ result: null, code: null });
  const [categories, setCategories] = useState({});
  const [id, setID] = useState(null);
  const [metrics, setMetrics] = useState({ result: null, code: null });
  const [transactions, setTransactions] = useState({
    result: null,
    code: null,
  });
  const [showmodal, setModal] = useState(true);
  const [manuallinkID, setManual] = useState(
    context.companyName !== "MAS Financial Pvt Ltd" &&
      context.companyName !== "MAS Financial Services Limited"
      ? true
      : false
  );
  let today = new Date(new Date().setDate(new Date().getDate() - 1));
  const d = new Date(today);
  const timep = context.timep;
  const f = new Date(addMonths(d, -timep));
  const fromDate = moment(f).format("DD/MM/YYYY");
  const toDate = moment(today).format("DD/MM/YYYY");
  const [src, setSrc] = useState();
  const [showsdk, setShowsdk] = useState(false);
  const [close, setClose] = useState(false);
  const [link, setLink] = useState("");
  const [trialExpired, setTrialExpired] = useState(false);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [recurring, setRecurring] = useState({ result: null, code: null });
  const [salary, setSalary] = useState({ result: null, code: null });
  const [lender, setLender] = useState({ result: null, code: null });
  const [downloadState, setDownloadState] = useState("loading");
  const [downloadLink, setDownloadLink] = useState("");
  const [errorState, setErrorState] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showSalaryModal, setShowSalaryModal] = useState(false);
  const [showRecurringModal, setShowRecurringModal] = useState(false);
  const [showLenderModal, setShowLenderModal] = useState(false);
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [showBankConnect, setShowBankConnect] = useState(false);
  const [validAccount, setValidAccount] = useState([]);

  useEffect(() => {
    const entity_id = props.match.params.entityId;
    if (!entity_id) window.location.href = "/";
    setID(entity_id);
    pollIdentity(
      context,
      setIdentity,
      "identity",
      entity_id,
      setErrorState,
      setAccountNum,
      setValidAccount
    );
    pollMetrics(
      context,
      setMetrics,
      "metrics",
      entity_id,
      setErrorState
      // setDownloadState
    );
    pollTransaction(
      context,
      setTransactions,
      "transactions",
      entity_id,
      setErrorState,
      setCategories
    );
    pollRecurring(
      context,
      setRecurring,
      "recurring_transactions",
      entity_id,
      setDownloadState,
      setDownloadLink
    );
    pollSalary(context, setSalary, "salary", entity_id, setErrorState);
    pollLender(
      context,
      setLender,
      "lender_transactions",
      entity_id,
      setErrorState
    );
  }, []);

  const onBankConnectExit = () => {
    setShowBankConnect(false);
    window.location.reload();
  };

  const onBankConnectSuccess = (payload) => {
    console.log("Payload -> ", payload);
    window.location.reload();
  };
  const ApiCall = () => {
    if (!aflag) {
      if (
        context.companyName !== "MAS Financial Pvt Ltd" &&
        context.companyName !== "MAS Financial Services Limited"
      ) {
        getSession();
      }
      setShowsdk(true);
      setModal(true);
      setClose(true);
    } else {
      setModal(true);
    }
  };
  const getSession = async () => {
    let fT = context.token;
    const ftData = JSON.parse(fT);
    var myHeaders = new Headers();
    myHeaders.append("token", ftData.Token);
    console.log("testtt", context.any);
    const requestBody = {
      stage: context.stage,
      fromDate: context.any == "true" ? undefined : fromDate,
      toDate: context.any == "true" ? undefined : toDate,
      linkID: localStorage.getItem("bankConnectLinkId"),
    };
    const requestOptions = {
      method: "POST",
      redirect: "follow",
      headers: myHeaders,
      body: JSON.stringify(requestBody),
    };
    let res;
    res = await fetch(
      "https://dashboardapi.finbox.in/v1/proxy/bank_connect_session",
      requestOptions
    );
    console.log(res);
    const json = await res.json();
    console.log(json);
    if (res.ok) {
      setSrc(json.redirect_url);
      setShowsdk(true);
      let payload;
      window.addEventListener("message", function (event) {
        if (event.data.status == "exit") {
          setShowsdk(false);
          setModal(false);
        }
        if (event.data.status == "success") {
          localStorage.setItem("bankConnectLinkId", event.data.payload.linkId);
          payload = event.data.payload;
          if (payload.entityId != null) {
            window.open("/bankconnect/results/" + payload.entityId, "_self");
          }
          setShowsdk(false);
          event.stopPropagation();
        }
      });
    } else {
      setShowsdk(false);
      setModal(false);
      console.log(json.Error);
    }
  };
  const aflag = JSON.parse(context.askflag);
  return (
    <ResultsContainer>
      {showBankConnect ? (
        aflag ? (
          <>
            <Finboxsdk
              showmodal={showmodal}
              setModal={setModal}
              askflag={aflag}
              setData={setData}
              setTotalPages={setTotalPages}
              data={data}
              currentPage={1}
              linkId={localStorage.getItem("bankConnectLinkId")}
              onPrimaryClick={() => {
                setShowBankConnect(true);
                setTrialExpired(false);
                context.updateaskFlag(false);
              }}
              onClose={onBankConnectExit}
            />
          </>
        ) : !manuallinkID ? (
          <>
            <Overlay style={{ display: close ? "flex" : "none" }}>
              <Banner1
                style={{
                  zIndex: "20",
                  marginTop: "15px",
                  padding: "10px 20px",
                }}
              >
                <div style={{ marginLeft: "270px" }}>
                  <button
                    style={{
                      background: "white",
                      borderColor: "white",
                      borderWidth: "0px",
                      tabSize: "20px",
                      cursor: "pointer",
                      padding: "10px",
                    }}
                    onClick={() => {
                      setClose(false);
                      setLink("");
                    }}
                  >
                    <MdClose />
                  </button>
                </div>
                <br />
                <img
                  src="https://finbox-cdn.s3.ap-south-1.amazonaws.com/assets/dashboard/modal.svg"
                  style={{ width: "60%", marginTop: "20px" }}
                />
                <br />
                <br />
                <div style={{ width: "100%" }}>
                  <span
                    style={{
                      color: "#3e3e3e",
                      fontWeight: "500",
                      marginBottom: "10px",
                    }}
                  >
                    Link Id
                  </span>
                  <input
                    value={link}
                    onChange={(e) => {
                      setLink(e.target.value);
                    }}
                    placeholder="Enter your link Id"
                    style={{ padding: "8px", width: "100%", marginTop: "6px" }}
                  />
                  <div
                    style={{
                      background: "#0075ff10",
                      padding: "5px",
                      width: "100%",
                      marginTop: "10px",
                      borderRadius: "4px",
                      fontSize: ".6rem",
                      color: "#0075ff",
                      display: "flex",
                      gap: "3px",
                    }}
                  >
                    <img
                      src={help}
                      style={{
                        height: ".7rem",
                        width: ".7rem",
                        alignItems: "center",
                        color: "#0075ff",
                        margin: "3px",
                      }}
                    />
                    <div>
                      LinkID can be any identifier that can be used to uniquely
                      identify the user at your end.
                    </div>
                  </div>
                </div>
                <ProceedButton
                  onClick={() => {
                    setManual(true);
                    getSession();
                  }}
                  style={{
                    width: "100%",
                    marginTop: "25px",
                    padding: "14px 25px",
                  }}
                >
                  Proceed
                </ProceedButton>
              </Banner1>
            </Overlay>
          </>
        ) : (
          <Finboxsdk
            src={src}
            showsdk={showsdk}
            linkId={localStorage.getItem("bankConnectLinkId")}
            setShowsdk={setShowsdk}
            showmodal={showmodal}
            setModal={setModal}
          />
        )
      ) : (
        ""
      )}
      {/* {showBankConnect && 
				<div style={{ position: "absolute", top: 0 }}>
					<FinBoxBankConnect
						linkId={localStorage.getItem("bankConnectLinkId")}
						apiKey={context.bankConnectApiKey}
						redirectUrl=""
						onExit={onBankConnectExit}
						onSuccess={onBankConnectSuccess}
					/>
				</div>
			)} */}
      {id && (
        <BreadCrumbsNavbar
          loc={[
            { name: "BankConnect", link: "/bankconnect" },
            { name: "Statements", link: "/bankconnect/list" },
            { name: id.slice(0, 8), link: props.location.pathname },
          ]}
        />
      )}
      <BCDemoContainer errorState={errorState}>
        <>
          <Sidebar
            setActiveIndex={setTabIndex}
            activeIndex={tabIndex}
            // setTabIndex={setTabIndex}
            // tabIndex={tabIndex}
            validAccount={validAccount}
            dna={props.location.state}
            identity={identity.result}
            metrics={metrics.result}
            salary={salary.result}
            transactions={transactions.result}
            apiCall={(flag) => {
              if (flag) {
                ApiCall();
              }
            }}
            // frd={frd}
            showBankConnect={(flag) => setShowBankConnect(flag)}
            isLoaned={
              lender.result &&
              lender.result.transactions &&
              lender.result.transactions.length > 0
            }
            isSalaried={
              salary.result &&
              salary.result.transactions &&
              salary.result.transactions.length > 0
            }
            accountNum={accountNum}
            setAccountNum={setAccountNum}
            setDownloadState={setDownloadState}
            downloadState={downloadState}
            downloadLink={downloadLink}
            errorState={errorState}
          />
          <BCDemoMain>
            <div style={{ height: "100%" }}>
              <ScrollingCard
                style={{
                  paddingTop: "0",
                  // overflowY: "hidden",
                  height: "100%",
                  overflowX: "hidden",
                }}
              >
                <Tabs
                  demo
                  setActiveIndex={setTabIndex}
                  activeIndex={tabIndex}
                  // tabIndex={tabIndex}
                  // setTabIndex={setTabIndex}
                >
                  {tabLabels.map((product, productIndex) => {
                    return (
                      <Tab demo key={productIndex} label={product.name}>
                        {renderKeys(product, {
                          metrics,
                          identity,
                          recurring,
                          lender,
                          salary,
                          transactions,
                          accountNum,
                          errorState,
                          categories,
                          showSalaryModal,
                          setShowSalaryModal,
                          showTransactionModal,
                          setShowTransactionModal,
                          showRecurringModal,
                          setShowRecurringModal,
                          showLenderModal,
                          setShowLenderModal,
                        })}
                      </Tab>
                    );
                  })}
                </Tabs>
              </ScrollingCard>
            </div>
          </BCDemoMain>
        </>
      </BCDemoContainer>
      {errorState && (
        <GenericErrorState
          heading="Unsupported Statement Format"
          message="This is either a new statement format or is a fraudulent statement. Our team has been notified."
        />
      )}
    </ResultsContainer>
  );
}

export default BCDemo;
